import { useState } from 'react';
import { Button, Typography } from 'antd';
import { Trans } from 'react-i18next';

import { useAppDispatch, useTranslate } from 'hooks';

import { deleteAccountRequest } from 'features/userSettings/actions';

import { ConfirmationModal } from 'componets/ui';

import s from './index.module.scss';

export const SettingsDeleteAccount = () => {
	const dispatch = useAppDispatch();
	const [isDeleteUserOpen, setIsDeleteUserOpen] = useState(false);

	const { deleteAccountText, deleteAccountModalText, yesText, cancelText } = useTranslate([
		'deleteAccountText',
		'deleteAccountModalText',
		'yesText',
		'cancelText',
	]);

	const onSendDeleteRequest = () => {
		dispatch(deleteAccountRequest())
			.unwrap()
			.catch(() => {})
			.finally(() => {
				setIsDeleteUserOpen(false);
			});
	};

	return (
		<>
			<div className={s.deleteWrapper}>
				<Typography.Text type="secondary">
					<Trans
						i18nKey="settingsDeleteAccountText"
						components={{
							button: (
								<Button
									type="link"
									className={s.delete}
									onClick={() => setIsDeleteUserOpen(true)}
								/>
							),
						}}
					/>
				</Typography.Text>
			</div>

			<ConfirmationModal
				onAgree={onSendDeleteRequest}
				text={deleteAccountModalText}
				submitText={yesText}
				cancelText={cancelText}
				loading={false}
				isOpen={isDeleteUserOpen}
				onClose={() => setIsDeleteUserOpen(false)}
				title={deleteAccountText}
			/>
		</>
	);
};
